export const checksums = {
  "content": "v3.5.0--pVbj2CxqZ2dD2eySIgzh5A1j3N1ov_buqziZkPpl4PM",
  "changelog": "v3.5.0--DbvNtppxoC2nVCqefsnABoXAlmwO8HRTdwcs61Ls64U",
  "faq": "v3.5.0--mUQuavl_Agl2AAbDSEGp3Q6OBhV3zYGZA79c4YIC_Pw"
}
export const checksumsStructure = {
  "content": "bgIYhpjRuV8zbHJE_CfelwKpJ_Td6YuGJwixiek8lmI",
  "changelog": "nZ-1bdpzgHfzOfa_npvLP_3s2C1X1LLTpNi_PLS79YY",
  "faq": "r9_aev8ZDIzHFCzGk8Ttwzbw83yn6oV8ydIET04TJKc"
}

export const tables = {
  "content": "_content_content",
  "changelog": "_content_changelog",
  "faq": "_content_faq",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json"
    }
  },
  "changelog": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "sitemap": "json",
      "date": "string"
    }
  },
  "faq": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "sitemap": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}